module.exports = __webpack_public_path__ + "static/img/img2.e80eb62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page_index/img2.png
// module id = gM4t
// module chunks = 1